import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { DeleteModal } from "shared/components";
import { dataMetaSelector, deleteEventTicketAndPass } from "Bands/state";
import { useClearActionMetaOnUnMount } from "Bands/utils";
import { BAND_ACTIONS, IGuestlistTicketAndPass } from "Bands/types";
import { IAPIState, IJSONAPIErrorCodes, IStatus } from "shared/types";
import { addTemporaryToast } from "shared/components/Toast";
import { copy } from "shared/assets";

const deleteCopy = copy.guestlistBlock.ticketAndPasses.delete;

interface DeleteTicketAndPassModalProps {
  ticketAndPass: IGuestlistTicketAndPass;
  blockId: string;
  handleClose: () => void;
}

export const DeleteTicketAndPassModal: React.FC<DeleteTicketAndPassModalProps> = ({
  ticketAndPass: { id, label },
  blockId,
  handleClose,
}) => {
  const dispatch = useDispatch();

  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.deleteEventTicketAndPass));
  useClearActionMetaOnUnMount(BAND_ACTIONS.deleteEventTicketAndPass);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      handleClose();

      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: deleteCopy.messages.success,
        })
      );
    }
  }, [apiMeta?.status, blockId, dispatch, handleClose]);

  const handleDelete = () => {
    dispatch(deleteEventTicketAndPass({ id, blockId }));
  };

  const error = useMemo(() => {
    const { errorCodes } = apiMeta?.error || {};

    if (errorCodes?.includes(IJSONAPIErrorCodes.TicketsDistributed)) {
      return deleteCopy.messages.ticketsDistributed;
    }

    if (errorCodes?.includes(IJSONAPIErrorCodes.LastTicketAndPass)) {
      return deleteCopy.messages.lastTicketAndPass;
    }

    return !!apiMeta?.error;
  }, [apiMeta?.error]);

  return (
    <DeleteModal
      name={label}
      type="ticket & pass"
      dataTestId="ticket_pass_delete_modal"
      apiMeta={apiMeta}
      error={error}
      handleClose={handleClose}
      handleDelete={handleDelete}
    />
  );
};
